import React from 'react';

const sections = [
  { id: 'publisher', title: 'Publisher' },
  { id: 'hosting', title: 'Hosting' },
  { id: 'intellectual-property', title: 'Intellectual Property' },
  { id: 'contact', title: 'Contact' },
];

const LegalNotice: React.FC = () => {
  return (
    <div className="px-4 py-10 sm:py-12 max-w-3xl mx-auto">
      {/* <a href="/" className="text-indigo-600 hover:text-indigo-800 text-sm">
        ← Back to home
      </a> */}
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
        Legal Notice
      </h1>
      <p className="text-gray-600 mt-2">
        Last updated: {new Date().toLocaleDateString('en-US')}
      </p>
      <section id="mentions-legales" className="scroll-mt-24 mt-10">
          <h3 className="text-lg font-semibold mb-4">Mentions légales</h3>
          <div className="space-y-6">
            <div>
              <h4 className="font-semibold mb-2">Siège social</h4>
              <p>P-TRON TECH<br />Baarerstrasse 112<br />CH-6300 Zoug<br />Courriel : support@cvmatchswiss.ch</p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">Bureau de contact</h4>
              <p>P-TRON TECH<br />Baarerstrasse 112<br />CH-6300 Zoug<br />Courriel : support@cvmatchswiss.ch</p>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <p>
                cvmatch.io est la plateforme d'emploi en ligne leader pour l'optimisation de 
                candidatures en Suisse. Trouvez l'emploi qui vous plaît sur cvmatch.io.
              </p>
              <p className="mt-2">
                cvmatch.io fait partie de P-TRON TECH, l'entreprise tech suisse leader sur le marché 
                de l'emploi assisté par intelligence artificielle. P-TRON TECH propose une variété de 
                solutions d'optimisation de candidatures innovantes. Son portefeuille comprend 
                CVMatchSwiss, plateforme d'analyse intelligente de CV et de génération de lettres de 
                motivation. Fondée en 2021 et établie à Zoug, l'entreprise est présente en Suisse et emploie 
                actuellement une équipe dédiée. P-TRON TECH est synonyme d'efficacité, d'innovation et de 
                transparence dans le secteur de l'optimisation de candidatures et aide les candidats à optimiser 
                leurs CV ainsi qu'à générer des lettres de motivation personnalisées pour décrocher l'emploi 
                de leurs rêves.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-2">Informations légales</h4>
              <ul className="space-y-1">
                <li><strong>Forme juridique :</strong> Raison individuelle</li>
                <li><strong>Secteur d'activité :</strong> Fourniture de services informatiques - Développement logiciel et applications</li>
                <li><strong>Inscription au registre du commerce :</strong> 15.04.2021</li>
                <li><strong>Numéro au registre du commerce :</strong> CH-170.1.010.871-6</li>
                <li><strong>N° IDE/TVA :</strong> CHE-242.634.861</li>
                <li><strong>Directeur de publication :</strong> P-TRON TECH</li>
              </ul>
            </div>
          </div>
        </section>
    </div>
  );
};

export default LegalNotice;
